<template>
    <v-flex
        md4
        sm6
        v-cloak
        xs12
    >
        <bread-crumb :items="managePersonBreadCrumbPath" />
        <v-divider />
        <v-card
            md4
            sm6
            v-cloak
            xs12
        >
            <v-simple-table id="userProfileTable">
                <tr>
                    <th>Name</th>
                    <td>
                        <div class="py-3">
                            {{ userProfile.name }}
                        </div>
                    </td>
                </tr>
                <tr>
                    <th>Email</th>
                    <td>
                        <div class="py-3">
                            {{ userProfile.email }}
                        </div>
                    </td>
                </tr>
            </v-simple-table>
        </v-card>
    </v-flex>
</template>
<script>
    import BreadCrumb from '@/components/BreadCrumb.vue';
    import {mapGetters} from "vuex";

    export default {

        name: "UserProfile",

        components: {
            BreadCrumb,
        },

        data() {
            return {
                breadcrumbPath: [''],
            };
        },

        computed:
        {
            managePersonBreadCrumbPath() {
                return [
                    {
                        text: 'Personnel',
                        to: {name: 'home'}
                    },
                    {
                        text: 'User Profile',
                        to: {name: 'user profile'}
                    }
                ];
            },

            ...mapGetters(
            [
                "userProfile",
            ]
            ),
        },
    }
</script>

<style scoped>
    #userProfileTable {
        margin-top: 1rem;
        width: 100%;
        text-align: left;
        padding-left: 16px;
    }
</style>
